import React, { useState } from "react";
import { SETTINGS_ROUTES } from "../../../../../../../consts/routes";
import { history } from "../../../../../../../history";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { ConfirmModal } from "../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { Button } from "../../../../../../../shared/Button/Button";
import { useSubmit } from "../../hooks/useSubmit";
import { useQuestionnaire } from "../../../../hooks/useQuestionnaire";
import { useForm } from "../../hooks/useForm";

export const ButtonSwitch = ({ questionnaireId, toProvider }) => {
  const { tSettings: t } = useAppTranslation.Settings();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const submit = useSubmit(questionnaireId, toProvider, {
    onError: () => {
      uiNotification.error(t("questionnaires.switch.error"));
    },
    onSuccess: () => {
      uiNotification.success(t("questionnaires.switch.success"));
      history.push(
        toProvider
          ? SETTINGS_ROUTES.providerQuestionnaires()
          : SETTINGS_ROUTES.healthTimelineQuestionnaires(),
      );
    },
  });

  const questionnaire = useQuestionnaire(questionnaireId);

  const form = useForm({
    submitter: submit.initiate,
    questionnaire: questionnaire.data || {},
  });

  const closeConfirm = () => setIsConfirmOpen(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        isDisabled={submit.isLoading}
        onClick={() => setIsConfirmOpen(true)}
        leftAdornment={
          submit.isLoading ? <CircularProgress size="small" /> : undefined
        }
      >
        {toProvider
          ? t("questionnaires.switch.toProvider")
          : t("questionnaires.switch.toMulti")}
      </Button>
      {isConfirmOpen && (
        <ConfirmModal
          isOpen
          isConfirming={submit.isLoading}
          onClose={closeConfirm}
          onCancel={closeConfirm}
          onConfirm={() => form.submitForm().then(closeConfirm)}
        >
          {t("questionnaires.switch.confirm")}
        </ConfirmModal>
      )}
    </>
  );
};
